import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-amount-input',
	templateUrl: './amount-input.component.html',
	styleUrls: ['./amount-input.component.scss'],
})
export class AmountInputComponent implements OnInit {
	@Output() getAmount = new EventEmitter();
	@Input() showError: boolean;
	@Input() errorMessage: string;
	@Input() minAmount: any;
	@Input() initialAmount: any;
	@Input() showAmountRange: boolean;
	@Input() disabled: boolean;
	@Input() maxAmount: any;

	inputClass = '';
	inputValue: any;
	error: boolean;

	constructor() {}

	ngOnInit(): void {
		this.initialize();
	}

	initialize() {
		if (this.errorMessage) {
			this.showError = true;
		}
		if (!this.minAmount) {
			this.minAmount = 0;
		}

		if (this.initialAmount) {
			const refinedAmount = parseFloat(this.initialAmount).toFixed(2);
			this.formatNumber({ value: refinedAmount });
		} else {
			this.inputValue = '0.00';
		}
	}

	formatNumber($event) {
		let amount = $event?.value?.toString().replace('.', '');
		amount = amount.replace(/[^\d]/g, '');

		const actualValue = this.parseAmount(amount);
		const dotPos = actualValue.length - 2;
		const nonDecimalSide = actualValue.substring(0, dotPos);
		const decimalSide = actualValue.substring(dotPos);

		const amountInCurrency = !nonDecimalSide && !decimalSide ? 0 : parseFloat(`${nonDecimalSide}.${decimalSide}`);

		const finalAmount = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(amountInCurrency);

		this.inputValue = finalAmount;

		this.emitAmount(actualValue);
	}

	emitAmount(amount: string) {
		const newAmount = Number(amount);
		const majorAmount = newAmount / 100;

		if (this.maxAmount) {
			if (majorAmount > this.maxAmount) {
				this.getAmount.emit(majorAmount);
				this.error = true;
				this.setInputClass(2);
				return;
			}
		}

		if (this.minAmount) {
			if (majorAmount < this.minAmount) {
				this.error = true;
				this.getAmount.emit(majorAmount);
				this.setInputClass(2);
				return;
			}
		}

		this.getAmount.emit(majorAmount);
		this.error = false;
		this.setInputClass(1);
		return;
	}

	parseAmount(amount: string) {
		let newAmount: any = '';
		const arr = amount.split(',');

		arr.forEach((e) => {
			newAmount += e;
		});

		return newAmount;
	}

	setInputClass(action: number) {
		if (this.error) {
			action = 2;
		} else if (this.disabled) {
			action = 3;
		}

		switch (action) {
			case 1:
				this.inputClass = 'focused';
				break;
			case 2:
				this.inputClass = 'error';
				break;
			case 3:
				this.inputClass = 'disabled';
				break;
			default:
				this.inputClass = '';
		}
	}
}
